<template>
  <main class="bg-[url('../../img/banner-people-optimized.jpg')] relative h-screen bg-cover bg-center">
    <div class="absolute inset-0 bg-black bg-opacity-60" />
    <router-view :key="$route.path" v-slot="{ Component }" class="relative z-10">
      <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
        <component :is="Component" />
      </transition>
    </router-view>
  </main>
</template>

<script>


export default {
  name: 'HomePageLayout',
  components: {},
}
</script>
